module.exports = __webpack_public_path__ + "img/2_118.472db748.png";